import React, { Component } from 'react';


class AddPage  extends Component {
    render(){
        return 'AddPage';
    }
}

export default AddPage;


// WEBPACK FOOTER //
// ./src/containers/Pages/add.js